export const AS_PLAYER_DEFAULTS = {
    'share': {
        // 'url': 'https://www.adultswim.com/special-link', // used to fully override share url as a whole
        //// Used to override pieces of the share url individually
        // 'basePath': 'https://www.adultswim.com/',
        // 'collectionSlug': 'streams',
        // 'videoSlug': 'special',
    },
    'tracking': true,

    'debug': false,
    'ads': true,

    'queryParamTimecode': true
};




// WEBPACK FOOTER //
// ./src/player/defaults/ASPlayer.js